// extracted by mini-css-extract-plugin
module.exports = {"header":"header_header__3Etv3","flexHeader":"header_flexHeader__3IagP","logo":"header_logo__21MLL","menu":"header_menu__3bxtu"};